import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import Layout from "../../components/Layout"
import * as permissionsApis from "../../utilities/apis/permissions"

const rows = {
  "ROLE": "ROLES",
  "USER": "USERS",
  "CATEGORY": "CATEGORIES",
  "PRODUCT": "PRODUCTS",
  "DEAL": "DEALS",
  "PRODUCT DEAL": "PRODUCT DEALS",
  "ZONES": "ZONES",
  "CUSTOMER": "CUSTOMERS",
  "DRIVER": "DRIVERS",
  "ORDER": "ORDERS",
  "ORDER REQUEST": "ORDER REQUESTS",
  "REQUEST": "REQUESTS",
  "CAMPAIGN": "CAMPAIGNS",
  "INCOME STATEMENT": "INCOME STATEMENTS",
  "CASH FLOW OUT": "CASH FLOW OUTS",
  "CASH FLOW IN": "CASH FLOW INS",
  "REPORT": "REPORTS",
  "INSIGHT": "INSIGHTS"
}

const Permissions = () => {
  const navigate = useNavigate()
  const { token, permissions: userPermissions } = useSelector((state) => state.user)

  const [roles, setRoles] = useState([])
  const [id, setId] = useState(null)
  const [role, setRole] = useState({})
  const [permissions, setPermissions] = useState({})

  const handleChange = async (e) => {
    const value = e.target.value
    setId(value)
    setRole(roles.find((role) => role.id === value))
  }


  const handleCheckboxChange = (permission) => {
    setPermissions((prevPermissions) => ({
      ...prevPermissions,
      [permission]: !prevPermissions[permission],
    }))
  }

  const handleSave = async () => {
    try {
      const allPermissions = {
        id: id,
        permissions: permissions
      }

      const response = await permissionsApis.updateRole(token, allPermissions)
      if (!response.status) throw new Error(response.message)

      alert("Permissions saved")
    } catch (error) {
      alert(error.message)
    }
  }

  const getRoles = async () => {
    try {
      const response = await permissionsApis.getRoles(token, role)
      if (!response.status) throw new Error(response.message)

      setRole(response.roles[0].name)
      setId(response.roles[0].id)
      setRoles(response.roles)
    } catch (error) {
      alert(error.message)
    }
  }

  const getRole = async () => {
    try {
      if (!id) return

      const response = await permissionsApis.getRole(token, id)
      if (!response.status) throw new Error(response.message)

      setPermissions(JSON.parse(response.role.permissions))
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getRoles()
  }, [])

  useEffect(() => {
    getRole()
  }, [id])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main id="drivers" className="py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <select
              value={role}
              onChange={handleChange}
              className="form-select rounded-4 text-capitalize"
              style={{ width: "25%" }}
            >
              {roles.map((role) => (
                <option key={role.id.toString()} value={role.id} className="text-capitalize">{role.name}</option>
              ))}
            </select>
            {userPermissions["UPDATE_ROLE"] && <button className="btn btn-theme rounded-4" onClick={handleSave}>Save</button>}
          </div>

          <div className="border rounded-4">
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "40%" }}>Feature</th>
                  <th scope="col" style={{ width: "10%" }} className="text-center">Create</th>
                  <th scope="col" style={{ width: "10%" }} className="text-center">Update</th>
                  <th scope="col" style={{ width: "10%" }} className="text-center">Delete</th>
                  <th scope="col" style={{ width: "10%" }} className="text-center">View All</th>
                  <th scope="col" style={{ width: "10%" }} className="text-center">View</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(rows).map((key) => {
                  switch (key) {
                    case "REPORT":
                      return (
                        <tr>
                          <td className="align-middle">{key}</td>
                          <td colSpan={5} className="align-middle">
                            <div className="row">
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="customer-count-value" checked={permissions["REPORT GET CUSTOMER COUNT VALUE"]} onChange={() => handleCheckboxChange("REPORT GET CUSTOMER COUNT VALUE")} />
                                  <label className="form-check-label" htmlFor="customer-count-value">CUSTOMER COUNT VALUE</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="zone-count-value" checked={permissions["REPORT GET ZONE COUNT VALUE"]} onChange={() => handleCheckboxChange("REPORT GET ZONE COUNT VALUE")} />
                                  <label className="form-check-label" htmlFor="zone-count-value">ZONE COUNT VALUE</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="customer-zone-count" checked={permissions["REPORT GET CUSTOMER ZONE COUNT"]} onChange={() => handleCheckboxChange("REPORT GET CUSTOMER ZONE COUNT")} />
                                  <label className="form-check-label" htmlFor="customer-zone-count">CUSTOMER ZONE COUNT</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="order-count-value" checked={permissions["REPORT GET ORDER COUNT VALUE"]} onChange={() => handleCheckboxChange("REPORT GET ORDER COUNT VALUE")} />
                                  <label className="form-check-label" htmlFor="order-count-value">ORDER COUNT VALUE</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="products" checked={permissions["REPORT GET PRODUCTS"]} onChange={() => handleCheckboxChange("REPORT GET PRODUCTS")} />
                                  <label className="form-check-label" htmlFor="products">PRODUCTS</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="zone-count-value" checked={permissions["REPORT GET ZONE COUNT VALUE"]} onChange={() => handleCheckboxChange("REPORT GET ZONE COUNT VALUE")} />
                                  <label className="form-check-label" htmlFor="zone-count-value">ZONE COUNT VALUE</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="customer-zone-count" checked={permissions["REPORT GET CUSTOMER ZONE COUNT"]} onChange={() => handleCheckboxChange("REPORT GET CUSTOMER ZONE COUNT")} />
                                  <label className="form-check-label" htmlFor="customer-zone-count">CUSTOMER ZONE COUNT</label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="order-count-value" checked={permissions["REPORT GET ORDER COUNT VALUE"]} onChange={() => handleCheckboxChange("REPORT GET ORDER COUNT VALUE")} />
                                  <label className="form-check-label" htmlFor="order-count-value">ORDER COUNT VALUE</label>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    case "INSIGHT":
                      return (
                        <tr>
                          <td className="align-middle">{key}</td>
                          <td colSpan={4} className="align-middle text-center"></td>
                          <td className="align-middle text-center">
                            <input className="form-check-input" type="checkbox" checked={permissions[`READ ${key}`]} onChange={() => handleCheckboxChange(`READ ${key}`)} />
                          </td>
                        </tr>
                      )
                    default:
                      return (
                        <tr>
                          <td className="align-middle">{key}</td>
                          <td className="align-middle text-center">
                            <input className="form-check-input" type="checkbox" checked={permissions[`CREATE ${key}`]} onChange={() => handleCheckboxChange(`CREATE ${key}`)} />
                          </td>
                          <td className="align-middle text-center">
                            <input className="form-check-input" type="checkbox" checked={permissions[`UPDATE ${key}`]} onChange={() => handleCheckboxChange(`UPDATE ${key}`)} />
                          </td>
                          <td className="align-middle text-center">
                            <input className="form-check-input" type="checkbox" checked={permissions[`DELETE ${key}`]} onChange={() => handleCheckboxChange(`DELETE ${key}`)} />
                          </td>
                          <td className="align-middle text-center">
                            <input className="form-check-input" type="checkbox" checked={permissions[`READ ${rows[key]}`]} onChange={() => handleCheckboxChange(`READ ${rows[key]}`)} />
                          </td>
                          <td className="align-middle text-center">
                            <input className="form-check-input" type="checkbox" checked={permissions[`READ ${key}`]} onChange={() => handleCheckboxChange(`READ ${key}`)} />
                          </td>
                        </tr>
                      )
                  }
                })}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Permissions